module.exports = __webpack_public_path__ + "assets/events_election_white.e80f4bdb.svg";